import {useCallback} from "react";
import {useLocation, useNavigate} from "react-router";

export const useSmoothScroll = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const scrollToSection = useCallback((sectionId) => {
        if (!sectionId) return;

        if (location.pathname === "/") {
            const element = document.getElementById(sectionId);
            if (element) {
                const prefersReducedMotion =
                    typeof window !== "undefined" &&
                    window.matchMedia &&
                    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

                element.scrollIntoView({
                    behavior: prefersReducedMotion ? "auto" : "smooth",
                    block: "start",
                });
                if (typeof window !== "undefined" && window.history && window.history.pushState) {
                    window.history.pushState(null, "", `#${sectionId}`);
                }
                return;
            }
        }

        navigate(`/#${sectionId}`);
    }, [location.pathname, navigate]);

    return scrollToSection;
};
